import store from "@/store/index";
import { post } from "@/plugins/axios";
/*
 * 产教融合基地信息添加/修改
 * @constructor jack
 * */
export const updateOrgCr = (org_name, org_code, org_license, username, zhiwu, phone, email, region_text, address, longitude, latitude, way, course,
    project_teachers,
    project_students,
    other,
    enrollment_plan,
    syllabus,
    teachers,
    funds,
    other_plan,
    project_leader,
    project_team,
    shenpi, remark, shen_type, u_token = store.state.token2
) => post("/org/updateOrgCr", {
    org_name,
    org_code,
    org_license,
    username,
    zhiwu,
    phone,
    email,
    region_text,
    address,
    longitude,
    latitude,
    way,
    course,
    project_teachers,
    project_students,
    other,
    enrollment_plan,
    syllabus,
    teachers,
    funds,
    other_plan,
    project_leader,
    project_team,
    shenpi,
    remark,
    shen_type,
    u_token
});

/*
 * 班级列表
 * @constructor jack、
 * */
export const classList = (class_name, page, list_rows, u_token = store.state.token2) => post("/org/class", {
    class_name,
    page,
    list_rows,
    u_token
})

/*
 * 班级添加修改
 * @constructor jack、
 * */
export const classAdd = (year, class_name, per_id, class_type, open_date, graduate_date, class_id, u_token = store.state.token2) => post("/org/classAdd", {
    year,
    class_name,
    per_id,
    class_type,
    open_date,
    graduate_date,
    class_id,
    u_token
})

/*
 * 教务列表
 * @constructor jack、
 * */
export const instructor = (u_token = store.state.token2) => post("/org/instructor", {
    u_token
})

/*
 * 班级删除
 * @constructor jack、
 * */
export const classDel = (class_id, u_token = store.state.token2) => post("/org/classDel", {
    class_id,
    u_token
})

/*
 * 班级信息
 * @constructor jack、
 * */
export const getClassInfo = (class_id, u_token = store.state.token2) => post("/org/getClassInfo", {
    class_id,
    u_token
})


/*
 * 学生列表
 * @constructor jack、
 * */
export const classStudent = (class_id, page, list_rows, stu_name, idcard, status, u_token = store.state.token2) => post("/org/classStudent", {
    class_id,
    page,
    list_rows,
    stu_name,
    idcard,
    status,
    u_token
})
export const classCodeImg = (class_id, u_token = store.state.token2) => post("/org/classCodeImg", {
    class_id,
    u_token
})


/*
 * 学生添加/修改
 * @constructor jack、
 * */
export const classStudentAdd = (class_id, stu_name, stu_idcard, stu_sex, img, stu_phone, political, nation, stu_id, u_token = store.state.token2) => post("/org/classStudentAdd", {
    class_id,
    stu_name,
    stu_idcard,
    stu_sex,
    img,
    stu_phone,
    political,
    nation,
    stu_id,
    u_token
})




export const setStudentStatus = (stu_id, status, reason, u_token = store.state.token2) => post("/org/setStudentStatus", {
    stu_id,
    status,
    reason,
    u_token
})



/*
 * 学生删除
 * @constructor jack、
 * */
export const classStudentDel = (stu_id, u_token = store.state.token2) => post("/org/classStudentDel", {
        stu_id,
        u_token
    })
    /*
     * 学生履历
     * @constructor jack、
     * */
export const studentResume = (stu_id, type = '', file_id = '', u_token = store.state.token2) => post("/org/studentResume", {
        stu_id,
        type,
        file_id,
        u_token
    })
    /*
     * 学生履历添加
     * @constructor jack、
     * */
export const addStudentResume = (stu_id, content, u_token = store.state.token2) => post("/org/addStudentResume", {
    stu_id,
    content,
    u_token
})

/*
 * 学生详情
 * @constructor jack、
 * */
export const studentInfo = (stu_id, u_token = store.state.token2) => post("/org/studentInfo", {
    stu_id,
    u_token
})


/*
 * 获取实习岗位列表
 *
 * */
export const stationSchoolList = (page, list_rows, org_name, sx_name, u_token = store.state.token2) => post("/org/stationSchoolList", {
        page,
        list_rows,
        org_name,
        sx_name,
        u_token
    })
    /*
     * 实习岗位推送
     *
     * */
export const setPush = (sx_id, class_id, u_token = store.state.token2) => post("/org/setPush", {
        sx_id,
        class_id,
        u_token
    })
    /*
     * 实习岗位取消推送
     *
     * */
export const setNoPush = (sx_id, u_token = store.state.token2) => post("/org/setNoPush", {
    sx_id,
    u_token
})

/*
 * 实习岗位学生列表
 *
 * */
export const practiceList = (sx_id, status, u_token = store.state.token2) => post("/org/practiceList", {
    sx_id,
    status,
    u_token
})


/*
 * 考试列表
 *
 * */
export const orgExamList = (page, list_rows, exam_name, exam_date, state, u_token = store.state.token2) => post("/org/orgExamList", {
    page,
    list_rows,
    exam_name,
    exam_date,
    state,
    u_token
})

/*
 * 考试详情
 *
 * */
export const getExam = (id, u_token = store.state.token2) => post("/org/getExam", {
    id,
    u_token
})

/*
 * 考试报名表
 *
 * */
export const getExamEnroll = (id, u_token = store.state.token2) => post("/org/getExamEnroll", {
    id,
    u_token
})

/*
 * 考试报名表
 *
 * */
export const getErweima = (exam_id, u_token = store.state.token2) => post("/org/getErweima", {
    exam_id,
    u_token
})


/*
 * 学生列表
 * @constructor jack、
 * */
export const orgExamStudentList = (exam_id, page, list_rows, stu_name, stu_phone, stu_idcard, u_token = store.state.token2) => post("/org/orgExamStudentList", {
        exam_id,
        page,
        list_rows,
        stu_name,
        stu_phone,
        stu_idcard,
        u_token
    })
    /*
     * 学生报名信息
     *
     * */
export const orgExamStudentInfo = (id, u_token = store.state.token2) => post("/org/orgExamStudentInfo", {
    id,
    u_token
})

/*
 * 学生报名信息
 *
 * */
export const dayCourseList = (class_id, date, u_token = store.state.token2) => post("/org/dayCourseList", {
    class_id,
    date,
    u_token
})

/*
 * 课程添加
 *
 * */
export const classCourseAdd = (class_id, course_name, teacher_name, teacher_id, course_time, u_token = store.state.token2) => post("/org/classCourseAdd", {
    class_id,
    course_name,
    teacher_name,
    teacher_id,
    course_time,
    u_token
})


/*
 * 课程表添加
 *
 * */
export const dayCourseAdd = (class_id, course_id, start_time, u_token = store.state.token2) => post("/org/dayCourseAdd", {
    class_id,
    course_id,
    start_time,
    u_token
})


/*
 * 课程列表
 * @constructor jack、
 * */
export const classCourse = (class_id, u_token = store.state.token2) => post("/org/classCourse", {
        class_id,
        u_token
    })
    /*
     * 课程列表
     * @constructor jack、
     * */
export const dayCourseDel = (id, u_token = store.state.token2) => post("/org/dayCourseDel", {
    id,
    u_token
})